// import { colors } from './../../../config/styles'

export default {
	checkbox: (disabled) => ({}),
}
